import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Injectable()

export class NextStatusSelectService extends ParentService {

  private dataChangeStatu =  new BehaviorSubject<any>(null);
  dataChangeStatu$ = this.dataChangeStatu.asObservable();

  constructor(private http: Http) {
    super();
  }

  dataChangeStatus(data) {
    this.dataChangeStatu.next(data);
  }

  getStatusByStatus(id: number) {
    const url = `${constant.URL_TRIP_STATUS_BY_STATU}/${id}`;
    return this.http
      .get(url, this.getHeader())
      .map((response) => response.json())
      .catch((error) => Observable.throw(error.json()));
  }

  getStatusByTrip(trip: number) {
    const url = `${constant.URL_TRIP_STATUS_BY_TRIP}/${trip}`;
    return this.http.get(url, this.getHeader())
      .map((response) => response.json())
      .catch((error) => Observable.throw(error.json()));
  }

  getNextStatus(data) {
    return this.http.post(constant.URL_NEXTSTATUS_TRIPS, data, this.headerPost())
    .map(res => res.json())
    .catch(err => Observable.throw(err.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/next-status-select/next-status-select.service.ts